import React from 'react'

function Doct() {
  return (
    <div>
      
    </div>
  )
}

export default Doct
